export default "__VITE_ASSET__CqhiU4Rn__"